import angular from 'angular';

import component from './scene-player-log.component';

export default angular.module('scene-player-log', [
])
	.component('scenePlayerLog', component);
